// extracted by mini-css-extract-plugin
export default {"title":"RecentCharges_title__nl72j"};